import { render, staticRenderFns } from "./Line-Item-Detail.vue?vue&type=template&id=98136310"
import script from "./Line-Item-Detail.vue?vue&type=script&lang=js"
export * from "./Line-Item-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports